import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { ApiInformalTradeConstants } from "../../constants/api-constants/api-informal-trade.constants";
let InformalTradeService = class InformalTradeService {
    http;
    constructor(http) {
        this.http = http;
    }
    getInformalTradeApplicationObservable(params) {
        return this.http.get(`${ApiInformalTradeConstants.URL}/${ApiInformalTradeConstants.FUNCTION_GET_MY_AFLA_INFORMAL_TRADING_APPLICATIONS}`, { params })
            .pipe(map((response) => {
            return response.value;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
InformalTradeService = __decorate([
    Injectable({
        providedIn: "root"
    })
], InformalTradeService);
export { InformalTradeService };
